/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Help_New_Product_AdditionInputs */



/**
* | output |
* | --- |
* | "Add a new product (gateway, th. head)" |
*
* @param {Users_Help_New_Product_AdditionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const users_help_new_product_addition = /** @type {((inputs?: Users_Help_New_Product_AdditionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Help_New_Product_AdditionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Add a new product (gateway, th. head)")
	return /** @type {LocalizedString} */ ("Ajout d'un nouveau produit (box, tête th.)")
});